import { gql } from 'apollo-boost';

export const getPageThemeQuery = gql`
  query Themes {
    Themes {
      id
      title
      palette {
        primary
        background
        cardBackground
        saparator
        coverBackaground
        coverText
        coverHasGradiant
        title
        subtitle
        description
      }
      createdBy
    }
  }
`;

export const newThemeQuery = gql`
  mutation NewTheme($title: String!, $palette: ThemePaletteInput!) {
    NewTheme(input: { title: $title, palette: $palette }) {
      id
      title
      palette {
        primary
        background
        cardBackground
        saparator
        coverBackaground
        coverText
        coverHasGradiant
        title
        subtitle
        description
      }
      createdBy
    }
  }
`;

export const editThemeQuery = gql`
  mutation EditTheme($id: ID!, $title: String!, $palette: ThemePaletteInput!) {
    EditTheme(input: { id: $id, title: $title, palette: $palette }) {
      id
      title
      palette {
        primary
        background
        cardBackground
        saparator
        coverBackaground
        coverText
        coverHasGradiant
        title
        subtitle
        description
      }
      createdBy
    }
  }
`;

export const removeThemeQuery = gql`
  mutation RemoveTheme($id: ID!) {
    RemoveTheme(input: { id: $id })
  }
`;

export const setThemeAsDefaultQuery = gql`
  mutation SetThemeAsDefault($id: ID!) {
    SetThemeAsDefault(input: { id: $id }) {
      id
      title
      palette {
        primary
        background
        cardBackground
        saparator
        coverBackaground
        coverText
        coverHasGradiant
        title
        subtitle
        description
      }
      createdBy
    }
  }
`;
